import type { TRuleWithTheme } from '@ackee/fela';

export const imgTitle: TRuleWithTheme = () => ({
    margin: '1rem 0 0.25rem 0',
});
export const extendContainer = () => ({
    position: 'relative',
    transition: 'opacity .4s ease, margin .4s ease',
    '&:hover': {
        '& img': {
            opacity: '0 !important',
        },
        '& .pixelated': {
            position: 'relative',
            zIndex: '299',
            '& img': {
                opacity: '1 !important',
            },
        },
        '& .testimonialPic.show img': {
            transform: 'scale(1.05)',
            opacity: '1 !important',
        },
        '& .dropShadow': {
            opacity: 'unset',
        },
    },
    tabletLarge: {
        width: '100%',
    },
});

export const extendTitle: TRuleWithTheme = () => ({
    marginTop: '1.25rem',
    marginBottom: '0.375rem',
    fontSize: '2rem',
    lineHeight: '2.5rem',
});

export const extendText: TRuleWithTheme = () => ({
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
});

export const extendTextWhite: TRuleWithTheme = ({ theme: { colors } }) => ({
    color: colors.white,
});

export const link: TRuleWithTheme = () => ({
    textDecoration: 'none',
    '& .wrapper': {
        position: 'relative',
    },
});

export const testimonial: TRuleWithTheme = ({ theme: { colors } }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '1.5rem',
});

// export const testimonialText: TRuleWithTheme = ({ theme: { colors } }) => ({
//     lineHeight: '26px',
// });

export const imgWrapper: TRuleWithTheme = ({ theme: { colors } }) => ({
    height: 'auto',
    position: 'absolute',
    zIndex: '-100',
    width: '100%',
});

export const testimonialContainer: TRuleWithTheme = ({ theme: { colors } }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '1.25rem',
    position: 'absolute',
    top: 0,
    zIndex: 300,
    margin: '2.63rem 1.75rem auto 1.75rem',
    desktopLarge: {
        margin: '2.63rem 5.56rem auto 1.75rem',
    },
});
